<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="management_role_links_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Management Role Links</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Management Role Links</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" v-if="editedIndex == -1">
                                                    <v-autocomplete v-model="editedItem.management_role_id"
                                                        label="Management Rrole" :items="management_role_list"
                                                        item-text="management_role_name" item-value="management_role_id"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-autocomplete v-model="editedItem.management_role_id"
                                                        label="Management Rrole" :items="management_role_list"
                                                        item-text="management_role_name" item-value="management_role_id"
                                                        persistent-hint></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.name" label="Name"
                                                        :rules="[(v) => !!v || 'required']" ref="name"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.link" label="Link "
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.icon" label="Icon "
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active?"></v-checkbox>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <!-- <template v-slot:no-data>
    <v-btn color="primary" @click="initialize">Reset</v-btn>
  </template> -->
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

    data: () => ({
        valid: false,
        // extraBreadcrumbItems: [
        //     { text: "Management Role Links", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style1",

        management_role_list: "",

        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,

        search: "",
        dialog: false,
        management_role_list: null,
        headers: [
            {
                text: "Management Role",
                align: "left",
                sortable: false,
                value: "management_role_name",
            },
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "name",
            },

            {
                text: "Link",
                align: "left",
                sortable: false,
                value: "link",
            },
            {
                text: "Icon",
                align: "left",
                sortable: false,
                value: "icon",
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
        ],
        management_role_links_list: [],
        editedIndex: -1,
        addedItem: {
            management_role_list: "",

        },
        editedItem: {
            managementRoleLinksId: "",
            name: "",
            link: "",
            isactive: true,
            icon: "",
            management_role_id: "",
        },
        defaultItem: {
            managementRoleLinksId: "",
            name: "",
            link: "",
            isactive: true,
            icon: "",
            management_role_id: "",
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Management Role Links" : "Edit Management Role Links";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },


    mounted() {
        this.onLoad();
    },
    methods: {


        editItem(item) {
            this.editedIndex = this.management_role_links_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Examination/getManagementRoleLinks")
                .then((res) => {
                    if (res.data.msg == "200") {


                        if ((this.load = true)) {
                            this.overlay = false;
                            this.management_role_links_list = res.data.management_role_links_list;
                            this.management_role_list = res.data.management_role_list;
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },



        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/Examination/editManagementRoleLinks", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {

                                Object.assign(this.management_role_links_list[this.editedIndex], this.editedItem);
                            }
                            this.showSnackbar("#4caf50", "Management Role Links Updated Successfully..."); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                //this.country_master_list.push(this.editedItem)
                axios
                    .post("/Examination/saveManagementRoleLinks", this.editedItem)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            //window.alert(res.data.status.code)
                            this.management_role_links_list.push(this.addedItem);
                            this.showSnackbar("#4caf50", "Management Role Links  Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            //window.alert(res.data.status.code)
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Management Role Links Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, //save()
        isValidated() {
            if (this.editedItem.name) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
